// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle--toggle--PHnn1","toggleIcon":"Toggle--toggleIcon--aKeWH","input":"Toggle--input--86NC6"};